import React, { useMemo } from "react";
import {
  MdAddCircle,
  MdPendingActions,
  MdDesignServices,
  MdAccountBalance,
  MdClose,
  MdHome,
  MdMenuBook,
  MdWork,
  MdBusiness,
  MdAutorenew,
  MdCalendarToday,
  MdTimer,
  MdWarning,
  MdMonetizationOn,
  MdConfirmationNumber,
} from "react-icons/md";
import {
  FaFileContract,
  FaRegImages,
  FaDraftingCompass,
  FaUsers,
  FaSignature,
  FaRegistered,
  FaLayerGroup,
} from "react-icons/fa";
import { RiFileEditLine } from "react-icons/ri";
import { TbLetterT } from "react-icons/tb";

import { Link, useNavigate } from "react-router-dom";
import { Container, Logo, Menu, Close } from "./styles";
import logo from "../../images/logo.png";
import { useAuth } from "../../hooks/AuthContext";
import { toast } from "react-toastify";

function Sidebar({ isMenuMinimized, onChange }) {
  const { user } = useAuth();
  const navigate = useNavigate();

  return (
    <Container isMenuMinimized={isMenuMinimized}>
      <Close
        onClick={() => {
          onChange();
        }}
      >
        <MdClose color="#fff" />
      </Close>
      <Logo isMenuMinimized={isMenuMinimized}>
        <img src={logo} alt="" />
      </Logo>
      <Menu isMenuMinimized={isMenuMinimized}>
        <li>
          <a
            onClick={() => {
              onChange(false);
              navigate(`/${user.type}/home`);
            }}
          >
            <MdHome size={22} />
            <span>Home</span>
          </a>
        </li>
        {(user.type == "cliente" || user.type == "tecnico") && (
          <li>
            <a
              onClick={() => {
                onChange(false);
                navigate(`/${user.type}/solicitacoes`);
              }}
            >
              <MdDesignServices size={22} />
              <span>Minhas OSs</span>
            </a>
          </li>
        )}
        {(user.type == "cliente" || user.type == "tecnico") && (
          <li>
            <a
              onClick={() => {
                onChange(false);
                navigate(`/${user.type}/financeiro`);
              }}
            >
              <MdAccountBalance size={22} />
              <span>Financeiro</span>
            </a>
          </li>
        )}
        {user.type == "admin" && (
          <li>
            <a
              onClick={() => {
                onChange(false);
                navigate(`/admin/pagamentos`);
              }}
            >
              <MdMonetizationOn size={22} />
              <span>Pagamentos</span>
            </a>
          </li>
        )}
        {user.type == "admin" && (
          <li>
            <a
              onClick={() => {
                onChange(false);
                navigate(`/admin/cupons`);
              }}
            >
              <MdConfirmationNumber size={22} />
              <span>Cupons de Desconto</span>
            </a>
          </li>
        )}
        {user.type == "cliente" && (
          <li>
            <a
              onClick={() => {
                onChange(false);
                navigate(`/${user.type}/pagamentos`);
              }}
            >
              <MdMonetizationOn size={22} />
              <span>Pagamentos</span>
            </a>
          </li>
        )}
        {user.type == "tecnico" && (
          <li>
            <a
              onClick={() => {
                onChange(false);
                navigate(`/${user.type}/open`);
              }}
            >
              <MdPendingActions size={22} />
              <span>OSs em Aberto</span>
            </a>
          </li>
        )}
        {user.type == "cliente" && (
          <li>
            <a
              onClick={() => {
                onChange(false);
                navigate(`/solicitacao`);
              }}
            >
              <MdAddCircle size={22} />
              <span>Solicitar OS</span>
            </a>
          </li>
        )}
        {user.type == "cliente" && user.courses_enabled && (
          <li>
            <a
              onClick={() => {
                onChange(false);
                navigate(`/courses`);
              }}
            >
              <MdMenuBook size={22} />
              <span>Área do Conhecimento</span>
            </a>
          </li>
        )}
        {user.type == "admin" && (
          <li>
            <a
              onClick={() => {
                onChange(false);
                navigate(`/admin/tecnicos`);
              }}
            >
              <FaDraftingCompass size={22} />
              <span>Técnicos</span>
            </a>
          </li>
        )}
        {user.type == "admin" && (
          <li>
            <a
              onClick={() => {
                onChange(false);
                navigate(`/admin/clientes`);
              }}
            >
              <FaUsers size={22} />
              <span>Franqueados</span>
            </a>
          </li>
        )}
        {user.type == "admin" && (
          <li>
            <a
              onClick={() => {
                onChange(false);
                navigate(`/admin/revenda`);
              }}
            >
              <FaRegistered size={22} />
              <span>Revenda treinamentos</span>
            </a>
          </li>
        )}
        {user.type == "admin" && (
          <li>
            <a
              onClick={() => {
                onChange(false);
                navigate(`/admin/assinatura`);
              }}
            >
              <FaSignature size={22} />
              <span>Assinatura</span>
            </a>
          </li>
        )}
        {user.type == "admin" && (
          <li>
            <a
              onClick={() => {
                onChange(false);
                navigate(`/admin/terceirize`);
              }}
            >
              <TbLetterT size={22} />
              <span>Terceirize</span>
            </a>
          </li>
        )}
        {user.type == "admin" && (
          <li>
            <a
              onClick={() => {
                onChange(false);
                navigate(`/admin/services`);
              }}
            >
              <MdWork size={22} />
              <span>Serviços</span>
            </a>
          </li>
        )}
        {user.type == "admin" && (
          <li>
            <a
              onClick={() => {
                onChange(false);
                navigate(`/admin/banners`);
              }}
            >
              <FaRegImages size={22} />
              <span>Banners</span>
            </a>
          </li>
        )}
        {user.type == "admin" && (
          <li>
            <a
              onClick={() => {
                onChange(false);
                navigate(`/admin/courses`);
              }}
            >
              <MdMenuBook size={22} />
              <span>Cursos</span>
            </a>
          </li>
        )}
        {user.type == "admin" && (
          <li>
            <a
              onClick={() => {
                onChange(false);
                navigate(`/contracts`);
              }}
            >
              <FaFileContract size={22} />
              <span>Propostas</span>
            </a>
          </li>
        )}
        {user.type == "admin" && (
          <li>
            <a
              onClick={() => {
                onChange(false);
                navigate(`/admin/credentials`);
              }}
            >
              <MdBusiness size={22} />
              <span>Credenciados</span>
            </a>
          </li>
        )}
        {user.type == "cliente" && user.leads_enabled && (
          <li>
            <a
              onClick={() => {
                if (!user.leads_enabled) {
                  toast.warn("Área restrita para franqueados");
                } else {
                  navigate("/contracts");
                }
              }}
            >
              <FaFileContract size={22} />
              <span>Propostas</span>
            </a>
          </li>
        )}
        {user.type == "cliente" && user.leads_enabled && (
          <li>
            <a
              onClick={() => {
                if (!user.leads_enabled) {
                  toast.warn("Área restrita para franqueados");
                } else {
                  navigate("/crm");
                }
              }}
            >
              <FaLayerGroup size={22} />
              <span>CRM</span>
            </a>
          </li>
        )}
        {user.type == "cliente" && !user.credentials_enabled && (
          <li>
            <a
              onClick={() => {
                if (!user.credentials_enabled) {
                  toast.warn("Área restrita para franqueados");
                } else {
                  navigate("/credentials");
                }
              }}
            >
              <MdBusiness size={22} />
              <span>Credenciados</span>
            </a>
          </li>
        )}
        {user.type == "admin" && (
          <li>
            <a
              onClick={() => {
                onChange(false);
                navigate(`/admin/orders`);
              }}
            >
              <FaUsers size={22} />
              <span>Todas OSs</span>
            </a>
          </li>
        )}
        {user.type == "admin" && (
          <li>
            <a
              onClick={() => {
                onChange(false);
                navigate(`/admin/leads`);
              }}
            >
              <FaUsers size={22} />
              <span>Leads</span>
            </a>
          </li>
        )}
        {user.type == "admin" && (
          <li>
            <a
              onClick={() => {
                onChange(false);
                navigate(`/admin/leads/fechados`);
              }}
            >
              <FaUsers size={22} />
              <span>Leads Fechados</span>
            </a>
          </li>
        )}
        {user.type == "cliente" && user.leads_enabled && (
          <li>
            <a
              onClick={() => {
                if (!user.leads_enabled) {
                  toast.warn("Área restrita para franqueados");
                } else {
                  onChange(false);
                  navigate(`/cliente/leads`);
                }
              }}
            >
              <FaUsers size={22} />
              <span>Leads Fechados</span>
            </a>
          </li>
        )}
        {user.type == "cliente" && (
          <li>
            <a
              onClick={() => {
                onChange(false);
                navigate(`/cliente/reminders`);
              }}
            >
              <MdTimer size={22} />
              <span>Lembretes</span>
            </a>
          </li>
        )}
        {user.type == "cliente" && (
          <li>
            <a
              onClick={() => {
                navigate("/companies");
              }}
            >
              <RiFileEditLine size={22} />
              <span>Formulário de Levantamento</span>
            </a>
          </li>
        )}
        {user.type == "admin" && (
          <li>
            <a
              onClick={() => {
                onChange(false);
                navigate(`/admin/comunicados`);
              }}
            >
              <MdWarning size={22} />
              <span>Comunicados</span>
            </a>
          </li>
        )}
      </Menu>
    </Container>
  );
}

export default Sidebar;
